export const renderBrowserTestingSections = (sections: readonly string[]): string =>
  sections.join('');
